/**
 * BINGO 基本スキーマ
 *
 * 再利用可能な基本的なバリデーションスキーマ
 */

import { z } from "zod";

// ============================================
// 基本スキーマ
// ============================================

/** ルームコードスキーマ（XXXX-XXXX 形式） */
export const RoomCodeSchema = z
  .string()
  .regex(/^[A-Z0-9]{4}-[A-Z0-9]{4}$/, "Invalid room code format");

/** ビンゴ番号スキーマ（1-75） */
export const BingoNumberSchema = z.number().int().min(1).max(75);

/** ニックネームスキーマ */
export const NicknameSchema = z
  .string()
  .min(1, "Nickname is required")
  .max(20, "Nickname must be 20 characters or less");

/** テーマIDスキーマ */
export const ThemeIdSchema = z.string().min(1);

/** 玉の数スキーマ（45=ショート, 60=ミディアム, 75=スタンダード） */
export const BallCountSchema = z.union([z.literal(45), z.literal(60), z.literal(75)]);
